/**
 * ESM shim over the VENDORED charts capability table.
 *
 * `vendored/capabilities.js` and `vendored/vectors.json` are copied
 * BYTE-IDENTICAL from keepr-api (`utils/analytics/`) and must never be edited
 * here — `__tests__/capabilities.vectors.test.js` drives the shared vectors
 * and byte-compares both files against keepr-api's main. The table says what
 * a chart may ask of each data type (keepr-web docs/plans/analytics.md §4.2),
 * so the builder offers exactly what the server's spec validator accepts.
 * The vendored file is CommonJS because the API runs it under Node; app code
 * imports from here and never reaches into `vendored/` directly.
 */
import capabilities from './vendored/capabilities';

export const {
	LIMITS,
	DEFAULT_BINS,
	OPS,
	ITEM_OPS,
	OP_ANSWERS,
	PART_OF_WHOLE_OPS,
	OP_VERBS,
	TIME_BUCKETS,
	DATE_BUCKETS,
	CYCLIC_BUCKETS,
	CLOCK_BUCKETS,
	ALL_BUCKETS,
	PRECISION_BUCKETS,
	RANGE_PRESETS,
	PRESET_MAX_DAYS,
	CUSTOM_RANGE_YEARS,
	MULTI_READINGS,
	EACH_DOOR_BUCKETS,
	KNOWN_MEASURES,
	NEVER_TOTAL_MEASURES,
	INTENSIVE_MEASURES,
	PER_UNIT_MEASURES,
	KQL_SYSTEM_NAMES,
	SYSTEM_FIELDS,
	KQL_FAMILIES,
	KQL_TEXT_FAMILY,
	KQL_FAMILY_LABELS,
	TYPE_KINDS,
	KINDS,
	GROUP_KINDS,
	FORMS,
	FORM_OPTIONS,
	OPTION_VALUES,
	COMPARE_FORMS,
	DOOR_REASONS,
	COUNTINGS,
	describeElementForCharts,
	describeColumnForCharts,
	describeSystemField,
	bucketAxis,
	kqlFamilyOf,
	sameKqlFamily,
	kqlFamilyLabel,
	isDay,
	rangeMaxDays,
	estimateBuckets,
	refusalFor,
	measureAnswer,
	formsForShape,
	defaultChartFor,
	drawLimit,
	foldFor,
	drawnCount,
	doorFor,
} = capabilities;

export default capabilities;
